module.exports = __webpack_public_path__ + "static/media/Hyundai-RN30.20af9803.jpg";